import { FC, HTMLProps } from 'react'
// @ts-ignore
import { css } from '@emotion/react'
import styled from '@emotion/styled'

type THtmlButton = HTMLProps<HTMLButtonElement> & {
    type?: 'button' | 'submit' | 'reset'
    className?: string
}

type TStyledLibButton = {
    minWidth?: string
    minHeight?: string
    noWrapWhiteSpace?: boolean
    hasHoverShadow?: boolean
    isSquared?: boolean
}

type LibButtonProps = THtmlButton & TStyledLibButton

const ButtonElement: FC<LibButtonProps> = ({
    children,
    className,
    minWidth,
    minHeight,
    noWrapWhiteSpace,
    hasHoverShadow,
    isSquared,
    type,
    ...props
}) => (
    <button type={type} className={className} {...props}>
        {/* @ts-ignore */}
        {children}
    </button>
)

const boxShadow = (shadowColor: string = 'rgba(1, 1, 1, 0.55)'): string => `
                box-shadow: 0 0 15px -1px ${shadowColor};
                -webkit-box-shadow: 0 0 15px -1px ${shadowColor};
                -moz-box-shadow: 0 0 15px -1px ${shadowColor};
            `

const LibButton = styled(ButtonElement)<LibButtonProps>`
    cursor: pointer;
    font-weight: 600;
    padding: 0.5rem 1.25rem;
    border-radius: ${({ isSquared }) => (isSquared ? '10px' : '100px')};

    min-height: ${({ minHeight }) => minHeight};
    min-width: ${({ minWidth }) => minWidth};
    white-space: ${({ noWrapWhiteSpace }) => (noWrapWhiteSpace ? 'nowrap' : 'normal')};

    // Force hardware acceleration to prevent flickering:
    transform: translate3d(0, 0, 0);
    -webkit-transform: translate3d(0, 0, 0);

    transition: all 0.15s ease-out;

    &:hover {
        ${({ hasHoverShadow, isOutlined }) => {
            if (!hasHoverShadow) return ''
            const shadowColor = isOutlined ? 'rgba(1, 1, 1, 0.25)' : 'rgba(1, 1, 1, 0.55)'

            return css`
                ${boxShadow(shadowColor)}
            `
        }}
    }
`

LibButton.defaultProps = {
    minHeight: '2.5rem',
    minWidth: '2.5rem',
    noWrapWhiteSpace: false,
    hasHoverShadow: true,
    isSquared: false,
}

export type { LibButtonProps }
export { LibButton, boxShadow }
